import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/accessibility-statement"
    exact
    path="/consumer/accessibility-statement"
    component={AsyncPage}
  />,
];
